import { find } from "lodash";

export const getLegendText = (convention, isChild) => {
    if (isChild) {
        return convention.parentType === "enveloppe" ? "" : "Convention rattachée";
    } else {
        const children = convention.childrenConventions || convention.children;
        if (children && children.length) {
            const parentType = find(children, ccn => ccn.parentType === "enveloppe");
            return parentType ? "" : "Convention de rattachement";
        }
        return "";
    }
};
